"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import { APIDataSource } from "@/components/grid/data-source";
import AddWebPagesGroupManager from "./addWebPages/AddWebPagesGroupManager.vue";
import EditWebResourceDialog from "./webResourceDialogs/EditWebResourceDialog.vue";
import { Debounce } from "vue-debounce-decorator";
import GroupManageDialog from "./webResourceDialogs/GroupManagerDialog.vue";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
let WebResources = class extends Vue {
  constructor() {
    super(...arguments);
    this.hide_system = false;
    this.search_info = "";
    this.empty_image = emptyImage;
    this.current_group_id = "";
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/web-resources")
    );
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  handleCommand(command) {
    switch (command) {
      case "add-web-page-handle":
        this.toAddWebPagesHandle();
        break;
      case "add-web-page-in-env":
        this.toAddWebPagesInEnv();
        break;
    }
  }
  //功能介绍指南
  openWebGuide() {
    window.open("https://www.kuajingvs.com/help2/24990", "__blank");
  }
  //打开分组管理弹窗
  openGroupManagerdialog() {
    this._group_manage_dialog.open();
  }
  //从环境中采集
  toAddWebPagesInEnv() {
    let url = this.$router.resolve("/virtual-shop");
    window.open(url.href, "__blank");
  }
  toAddWebPagesHandle() {
    this.$router.push("/add_web_pages_handle");
  }
  openDisplayDialog() {
  }
  selectItems(items) {
  }
  refresh() {
    return __async(this, null, function* () {
      yield this._web_pages_group_manager.refresh();
    });
  }
  searchWebResource() {
    return __async(this, null, function* () {
      try {
        if (this.search_info !== "" && this.search_info !== null) {
          this.gridController.query.filter = `(name=like='${this.search_info}',url=like='${this.search_info}',description=like='${this.search_info}');groupId == ${this.current_group_id};createdTime=sort=desc`;
        } else {
          this.gridController.query.filter = `groupId == ${this.current_group_id};createdTime=sort=desc`;
        }
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //打开分组管理弹窗
  opendialog() {
  }
  //打开网页管理弹窗
  editWebResource(item) {
    return __async(this, null, function* () {
      yield this._edit_web_resource.open(item);
    });
  }
  //删除网页资源
  deleteWebResource(item) {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("safemanager.web_resource.delete_item_tips", {
            name: item.name
          }),
          this.$t("vdcontainer.hint"),
          {
            confirmButtonText: this.$t("vdcontainer.determine"),
            cancelButtonText: this.$t("vdcontainer.cancel"),
            type: "warning"
          }
        );
        yield API.delete(`api://base.auth/api/v1/web-resources/${item.id}`);
        this.$message.success(
          this.$t("safemanager.web_resource.delete_success")
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  groupChange(index) {
    return __async(this, null, function* () {
      this.current_group_id = index.id;
      this.search_info = "";
      this.gridController.query.filter = `groupId == ${index.id};createdTime=sort=desc`;
      yield this.gridController.search();
    });
  }
};
__decorateClass([
  Ref("web-pages-group-manager")
], WebResources.prototype, "_web_pages_group_manager", 2);
__decorateClass([
  Ref("editWebResourceDialog")
], WebResources.prototype, "_edit_web_resource", 2);
__decorateClass([
  Ref("groupManageDialog")
], WebResources.prototype, "_group_manage_dialog", 2);
__decorateClass([
  Debounce(400)
], WebResources.prototype, "searchWebResource", 1);
WebResources = __decorateClass([
  Component({
    components: {
      UiGrid,
      AddWebPagesGroupManager,
      EditWebResourceDialog,
      GroupManageDialog
    }
  })
], WebResources);
export {
  WebResources as default
};
